/*@flow*/
import { InMemoryCache } from 'apollo-cache-inmemory';
import { CachePersistor } from 'apollo-cache-persist';
import { local } from 'lib/storage';
import ApolloClient from 'apollo-client';
import type { DocumentNode } from 'graphql';

const cache = new InMemoryCache({ addTypename: false });
type Record = { [key: string]: any };

export default ({
  resolvers = {},
  typeDefs = {},
  key = 'apollo-cache-local',
}: {
  resolvers?: Record,
  typeDefs?: DocumentNode,
  key?: string,
}): {|cache: any, client: any, persistor: any|} => {
  const persistor = new CachePersistor({
    cache,
    storage: local,
    key,
    trigger: 'write',
  });

  const client = new ApolloClient<*>({
    cache,
    resolvers,
    typeDefs,
  });

  return { client, persistor, cache };
};
